import { generateClient } from 'aws-amplify/api';
import { notificationsByUserId } from "../graphql/queries";

const client = generateClient();

export default async (userId, limit) => {
    const {
        data: { notificationsByUserId: { items: notifications } },
    } = await client.graphql({
        query: notificationsByUserId,
        variables: {
            userId,
            limit,

        },
    });
    return notifications;
}
